export default "__VITE_ASSET__DjnKel1u__"